<template>
  <v-container fluid>
    <v-card
      elevation="0"
      outlined
    >
      <v-card-title>Cut Sheets</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="name"
                :rules="[(v) => (!!v || 'Work Order is required')]"
                @keyup.enter="submit"
              >
                <template slot="label">
                  Work Order<RedAsterisk />
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-btn
                class="mt-3"
                color="primary"
                outlined
                @click="submit"
                @keyup.enter="submit"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col class="mt-5">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            :loading="loading"
            dense
            fixed-header
            :height="windowHeight"
            :server-items-length="total"
            @update:options="updateOptions"
          >
            <template #[`item.class`]="{ item }">
              <v-chip
                small
                :color="item && item.job && item.job.class ? item.job.class.color : ''"
                text-color="white"
              >
                <text-highlight :queries="search">
                  {{ item && item.job && item.job.class ? item.job.class.name : '' }}
                </text-highlight>
              </v-chip>
            </template>
            <template #[`item.id`]="{ item }">
              <text-highlight :queries="search">
                {{ item.id }}
              </text-highlight>
            </template>
            <template #[`item.name`]="{ item }">
              <text-highlight :queries="search">
                {{ item.name }}
              </text-highlight>
            </template>
            <template #[`item.created_by`]="{ item }">
              <text-highlight :queries="search">
                {{ item.user? item.user.first_name + ' ' + item.user.last_name : '' }}
              </text-highlight>
            </template>
            <template #[`item.created_at`]="{ item }">
              <text-highlight :queries="search">
                {{ item.created_at }}
              </text-highlight>
            </template>
            <!-- <template #[`item.updated_at`]="{ item }">
              <text-highlight :queries="search">
                {{ item.updated_at }}
              </text-highlight>
            </template> -->
            <template #[`item.actions`]="{ item }">
              <v-menu offset-y>
                <template #activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    class="ml-1 mt-1 mb-1"
                    color="orange"
                    outlined
                    small
                    v-on="on"
                  >
                    REPORTS
                  </v-btn>
                </template>
                <v-list
                  class="pa-3"
                >
                  <v-list-item
                    @click="runWebhook(item, 63)"
                    v-if="renderPanelLabels(item)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          PANEL LABELS
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="runWebhook(item, 61)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          SCREEN REPORT
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="runWebhook(item, 56)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          COMMERCIAL PANEL
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="runWebhook(item, 51)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          WINDOW LABELS
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="download(item, true)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          PANEL PDF
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="download(item, false)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          PROFILE PDF
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="runWebhook(item, 66)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          COMM LABELS
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="runWebhook(item, 68)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          SCREEN LABELS
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item
                    @click="runWebhook(item, 67)"
                  >
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          COMM DOOR LABELS
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
              <!-- <v-btn
                class="ml-1 mt-1 mb-1"
                color="orange"
                outlined
                small
                @click="runWebhook(item, 61)"
              >
                SCREEN REPORT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="orange"
                outlined
                small
                @click="runWebhook(item, 56)"
              >
                COMMERCIAL PANEL
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="orange"
                outlined
                small
                @click="runWebhook(item, 51)"
              >
                WINDOW LABELS
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="orange"
                outlined
                small
                @click="download(item, true)"
              >
                PANEL PDF
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="orange"
                outlined
                small
                @click="download(item, false)"
              >
                PROFILE PDF
              </v-btn> -->
              <v-btn
                v-if="isAdmin || isCommercialScheduleAdmin || isPanelAdmin || isAssociate"
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="softDelete(item)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import * as FormatHelpers from '@/helpers/FormatHelpers';
import { saveAs } from 'file-saver';
import { mapState, mapGetters } from 'vuex';

export default {
  data: () => ({
    name: '',
    items: [],
    headers: [
      { text: 'Class', value: 'class', align: 'center', width: '5%' },
      { text: 'Id', value: 'id', align: 'center', width: '5%' },
      { text: 'Work Order', value: 'name' },
      { text: 'Created By', value: 'created_by' },
      { text: 'Created At', value: 'created_at' },
      // { text: 'Updated At', value: 'updated_at' },
      {
        text: 'Actions', value: 'actions', align: 'end', width: '30%', sortable: false,
      },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, -1],
    },
    pagination: {
      itemsPerPage: 20,
      page: 1,
    },
    sort: {
      order_by_first: 'created_at',
      direction_sort: true,
    },
    topSpaceHeight: 322,
    windowHeight: 1000,
    total: 0,
    types: [],
    loading: false,

    roles: [],
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdPanelAdmin: 38,
    userRoleIdCommercialScheduleAdmin: 41,
    userRoleIdCutSheetHandler: 35,

    customPanelWorkflow4800: false,
    customPanelWorkflow6000: false,
  }),

  computed:
  {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),

    isCutSheetHandler() {
      return this.roles.includes(this.userRoleIdCutSheetHandler);
    },
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    isAssociate() {
      return this.roles.includes(this.userRoleIdAssociate);
    },
    isPanelAdmin() {
      return this.roles.includes(this.userRoleIdPanelAdmin);
    },
    isCommercialScheduleAdmin() {
      return this.roles.includes(this.userRoleIdCommercialScheduleAdmin);
    },
  },

  watch: {
    pagination() {
      this.get();
    },
    search() {
      this.get();
    },
  },

  created() {
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.roles = this.user.roles.map((x) => x.id);
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    init() {
      this.get();
      const customPanelWorkflow4800 = '4800 Custom Panel Workflow';
      this.customPanelWorkflow4800 = this.businessRulesGetBoolean(customPanelWorkflow4800);
      const customPanelWorkflow6000 = '6000 Custom Panel Workflow';
      this.customPanelWorkflow6000 = this.businessRulesGetBoolean(customPanelWorkflow6000);
    },
    async get() {
      this.loading = true;
      const submitModel = {
        search: this.search,
        pagination: this.pagination,
        sort: this.sort,
      };
      const res = await this.$api.cutSheet.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data) {
        this.$bus.$emit('showError');
        this.items = [];
        this.total = 0;
        return;
      }
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    },

    async submit() {
      if (!await this.$refs.form.validate()) return;

      this.$bus.$emit('loading');

      const submitData = {
        name: this.name,
      };

      const res = await this.$api.cutSheet.store(submitData);

      this.$bus.$emit('loading');

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      if (res === '1000') {
        this.$bus.$emit('showError', `Job for Work Order ${this.name} does not exist in ERP`);
        return;
      }
      if (res === '1001') {
        this.$bus.$emit('showError', `Cut Sheet for Work Order ${this.name} already exists`);
        return;
      }

      this.$bus.$emit('showSuccess');
      this.parser = {
        name: '',
      };

      await this.$refs.form.reset();
      this.get();
    },

    async download(item, isPanel) {
      this.$bus.$emit('loading');
      const submitData = {
        path: isPanel ? item.panel_report_path : item.profile_report_path,
      };
      const pdf = await this.$api.cutSheet.store(submitData, 'download', { responseType: 'blob' });
      if (!pdf) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading');
        return;
      }
      const now = FormatHelpers.getFileTimestamp();
      const fileName = `${item.name}_${isPanel ? 'Panel_Report' : 'Profile_Report'}_${now}`;
      const file = new Blob([pdf], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

    async softDelete(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this item?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.cutSheet.delete(item.id);
      this.$bus.$emit('loading-stop');
      if (res === '1001') {
        this.$bus.$emit('showError', `Job ${item.name} is already in production`);
        return;
      }

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.get();
    },

    async runWebhook(item, moduleId) {
      this.$bus.$emit('loading');

      const webhookModuleIdWindowLabels = moduleId;
      const webhookData = {
        module_id: webhookModuleIdWindowLabels,
        work_order: item.name,
      };

      const res = await this.$api.webhook.store(webhookData, 'run-download', { responseType: 'blob' });
      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading');
        return;
      }

      let moduleName = '';
      switch (moduleId) {
        case 63:
          moduleName = 'Panel_Labels';
          break;
        case 61:
          moduleName = 'Screen_Report';
          break;
        case 56:
          moduleName = 'Commercial_Panel';
          break;
        case 51:
          moduleName = 'Window_Labels';
          break;
        case 66:
          moduleName = 'COMM_Frame_Labels';
          break;
        case 67:
          moduleName = 'COMM_Door_Labels';
          break;
        case 68:
          moduleName = 'Screen_Labels';
          break;
        default:
          moduleName = '';
      }

      const now = FormatHelpers.getFileTimestamp();
      const fileName = `${item.name}_${moduleName}_${now}`;

      const file = new Blob([res], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

    renderPanelLabels(item) {
      const itemClassName = item.job && item.job.class ? item.job.class.name : '';
      if (this.customPanelWorkflow4800 && itemClassName.includes('4800')) return false;
      if (this.customPanelWorkflow6000 && itemClassName.includes('6000')) return false;
      return true;
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
    },
  },
};
</script>
